import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { AuthService, provideAuth0 } from '@auth0/auth0-angular';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import CustomTheme from '../style/vendor/primeng/themes/custom-theme/custom-theme';
import { httpInterceptors } from './core/config/http-interceptors';
import { ConfirmationService, MessageService } from 'primeng/api';
// import { CognitoAuthService } from './shared/service/cognito-auth.service';
import { appRoutes } from './app.routes';
import { AUTH0_PROVIDER } from './shared/common/injector-token';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateConfig } from './core/config/translate.config';
import { provideStore } from '@ngxs/store';
import {
  ngxsConfig,
  ngxsStates,
  ngxsStorageConfig,
} from './core/config/ngxs.config';
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { withNgxsRouterPlugin } from '@ngxs/router-plugin';
import { environment } from '../environment/environment';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';

const globalServices = [
  { provide: AUTH0_PROVIDER, useExisting: AuthService },
  MessageService,
  ConfirmationService,
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideAuth0({
      domain: environment.auth0!.domain,
      clientId: environment.auth0!.clientId,
      useRefreshTokens: true,
      cacheLocation: 'localstorage',
      authorizationParams: {
        audience: environment.auth0!.audience,
        redirect_uri: window.location.origin,
      },
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withRouterConfig({ paramsInheritanceStrategy: 'always' })),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    TranslateModule.forRoot(TranslateConfig).providers!,
    providePrimeNG({
      ripple: false,
      theme: {
        preset: CustomTheme,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark-mode',
          cssLayer: {
            name: 'primeng',
            order:
              'normalize, app-styles, primeng, primeicons, primeflex, custom',
          },
        },
      },
    }),
    provideStore(
      ngxsStates,
      ngxsConfig,
      withNgxsStoragePlugin(ngxsStorageConfig),
      withNgxsRouterPlugin({}),
      withNgxsReduxDevtoolsPlugin()
    ),
    ...httpInterceptors,
    ...globalServices,
  ],
};
